import { useEffect } from 'react';
import { fetchProducts } from '@/lib/api';

/**
 * Injects JSON-LD ItemList of Product schemas into <head> for SEO.
 * Non-visual — helps Google render rich product results.
 */
export default function ProductSchema() {
  useEffect(() => {
    let scriptEl;
    let cancelled = false;

    (async () => {
      try {
        const products = await fetchProducts();
        if (cancelled || !products?.length) return;

        const items = products.slice(0, 100).map((p, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          item: {
            '@type': 'Product',
            '@id': `https://themeatworks.com.au/#product-${p.id}`,
            name: p.name,
            description: p.description || p.cut || '',
            category: p.category,
            brand: { '@type': 'Brand', name: 'The Meat Works' },
            ...(p.image_url ? { image: p.image_url } : {}),
            offers: {
              '@type': 'Offer',
              availability: 'https://schema.org/InStock',
              priceCurrency: 'AUD',
              price: '0',
              priceSpecification: {
                '@type': 'PriceSpecification',
                valueAddedTaxIncluded: false,
              },
              url: `https://themeatworks.com.au/#contact`,
              seller: { '@type': 'Organization', name: 'The Meat Works' },
            },
          },
        }));

        const payload = {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: items,
        };

        scriptEl = document.createElement('script');
        scriptEl.type = 'application/ld+json';
        scriptEl.id = 'ld-products';
        scriptEl.textContent = JSON.stringify(payload);
        document.head.appendChild(scriptEl);
      } catch {
        /* ignore — SEO is best-effort */
      }
    })();

    return () => {
      cancelled = true;
      const existing = document.getElementById('ld-products');
      if (existing) existing.remove();
    };
  }, []);

  return null;
}
